<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="row mx-0">
          <div class="col-xl-12 col-md-12 col-sm-12 p-2">
            <div class="card">
              <div class="card-body">
                <div class="row align-items-center rental-payment mb-md-4">
                  <div class="col mt-4">
                    <h4 class="ms-2">User Profile</h4>
                  </div>

                  <div
                    class="col-12 col-sm-6 col-md-4 d-flex justify-content-end me-2 add-btn"
                    v-if="roleId == 4"
                  >
                    <llp-button
                      :load-spinner="showaddadminSpinner"
                      classNames="btn-secondary new-btn"
                      @click="BackToDashboard()"
                    >
                      Back To Services
                    </llp-button>
                  </div>

                  <div
                    class="col-12 col-sm-6 col-md-4 d-flex justify-content-end me-2 add-btn"
                    v-else
                  >
                    <llp-button
                      :load-spinner="showaddadminSpinner"
                      classNames="btn-secondary new-btn d-none d-sm-block"
                      @click="BackToDashboard()"
                    >
                      Back To User Management
                    </llp-button>

                    <llp-button
                      :load-spinner="showaddadminSpinner"
                      classNames="btn-secondary new-btn d-block d-sm-none"
                      @click="BackToDashboard()"
                    >
                      Go Back
                    </llp-button>
                  </div>
                </div>
                <form
                  ref="laddadmin"
                  class="d-grid table-data"
                  @submit.prevent="updateUserDetails"
                >
                  <div class="row p-2">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="firstName" :aria-label="FirstName">
                        First Name:
                      </llp-label>
                      <llp-input
                        id="firstName"
                        v-model="userdata.firstName"
                        :errors="validator.userdata.firstName.$errors"
                      ></llp-input>
                      <div v-if="formErrors.firstName" class="text-danger">
                        <span>{{ formErrors.firstName[0] }}</span>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="lastName" :aria-label="LastName">
                        Last Name:
                      </llp-label>
                      <llp-input
                        id="lastName"
                        v-model="userdata.lastName"
                        :errors="validator.userdata.lastName.$errors"
                      ></llp-input>
                      <div v-if="formErrors.lastName" class="text-danger">
                        <span>{{ formErrors.lastName[0] }}</span>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="mobile" :aria-label="Email">
                        Mobile:
                      </llp-label>
                      <llp-input
                        id="mobile"
                        v-model="userdata.mobile"
                        :errors="validator.userdata.mobile.$errors"
                      ></llp-input>
                      <div v-if="formErrors.mobile" class="text-danger">
                        <span>{{ formErrors.mobile[0] }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="address" :aria-label="Address">
                        Address:
                      </llp-label>
                      <llp-input
                        id="address"
                        v-model="userdata.address"
                        :errors="validator.userdata.address.$errors"
                      ></llp-input>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="city" :aria-label="City">
                        City:
                      </llp-label>
                      <llp-input
                        id="City"
                        v-model="userdata.city"
                        :errors="validator.userdata.city.$errors"
                      ></llp-input>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="state" :aria-label="State">
                        State:
                      </llp-label>
                      <select
                        id="state"
                        class="form-control select-dropdown"
                        v-model="userdata.state"
                      >
                        <option value="" disabled selected>
                          Select your state
                        </option>
                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                        <option value="Arunachal Pradesh">
                          Arunachal Pradesh
                        </option>
                        <option value="Assam">Assam</option>
                        <option value="Bihar">Bihar</option>
                        <option value="Chhattisgarh">Chhattisgarh</option>
                        <option value="Goa">Goa</option>
                        <option value="Gujarat">Gujarat</option>
                        <option value="Haryana">Haryana</option>
                        <option value="Himachal Pradesh">
                          Himachal Pradesh
                        </option>
                        <option value="Jammu and Kashmir">
                          Jammu and Kashmir
                        </option>
                        <option value="Jharkhand">Jharkhand</option>
                        <option value="Karnataka">Karnataka</option>
                        <option value="Kerala">Kerala</option>
                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                        <option value="Maharashtra">Maharashtra</option>
                        <option value="Manipur">Manipur</option>
                        <option value="Meghalaya">Meghalaya</option>
                        <option value="Mizoram">Mizoram</option>
                        <option value="Nagaland">Nagaland</option>
                        <option value="Odisha">Odisha</option>
                        <option value="Punjab">Punjab</option>
                        <option value="Rajasthan">Rajasthan</option>
                        <option value="Sikkim">Sikkim</option>
                        <option value="Tamil Nadu">Tamil Nadu</option>
                        <option value="Telangana">Telangana</option>
                        <option value="Tripura">Tripura</option>
                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                        <option value="Uttarakhand">Uttarakhand</option>
                        <option value="West Bengal">West Bengal</option>
                        <option value="Chandigarh">Chandigarh</option>
                        <option value="Lakshadweep">Lakshadweep</option>
                        <option value="Delhi">Delhi</option>
                        <option value="Puducherry">Puducherry</option>
                      </select>
                    </div>
                  </div>
                  <div class="row p-2">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="pinCode" :aria-label="PinCode">
                        Pincode:
                      </llp-label>
                      <llp-input
                        id="pinCode"
                        v-model="userdata.pinCode"
                        :errors="validator.userdata.pinCode.$errors"
                      ></llp-input>
                      <div v-if="formErrors.pincode" class="text-danger">
                        <span>{{ formErrors.pincode[0] }}</span>
                      </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="email" :aria-label="email">
                        Email:
                      </llp-label>
                      <llp-input
                        id="email"
                        v-model="userdata.email"
                        disabled
                      ></llp-input>
                    </div>
                  </div>
                  <h5 class="ms-2 mt-2">Business Details</h5>
                  <div class="row p-2">
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="businessName" :aria-label="BusinessName">
                        Business Name:
                      </llp-label>
                      <llp-input
                        id="businessName"
                        v-model="userdata.businessName"
                      ></llp-input>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label id="contactNumber" :aria-label="ContactNumber">
                        Contact Number:
                      </llp-label>
                      <llp-input
                        id="contactNumber"
                        v-model="userdata.contactNumber"
                        maxlength="10"
                      ></llp-input>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-6">
                      <llp-label
                        id="businessAddress"
                        :aria-label="BusinessAddress"
                      >
                        Business Address:
                      </llp-label>
                      <llp-input
                        id="businessAddress"
                        v-model="userdata.businessAddress"
                      ></llp-input>
                    </div>
                  </div>

                  <div class="col">
                    <div class="row mt-2 p-0">
                      <div
                        class="col d-flex justify-content-start justify-content-md-end edit-btn"
                      >
                        <llp-button
                          :load-spinner="submitloadingSpinner"
                          classNames="btn-secondary mb-3 new-btn"
                          type="submit"
                        >
                          Update Profile
                        </llp-button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import { helpers, required,numeric,maxLength } from "@vuelidate/validators";
import NetworkService from "@/services/network.service";

export default {
  setup: () => ({ validator: useVuelidate() }),

  data() {
    return {
      userId: localStorage.getItem("User_id"),
      roleId: localStorage.getItem("role_id"),
      formErrors: {},
      submitloadingSpinner: false,
      userdata: {
        firstName: "",
        lastName: "",
        mobile: "",
        address: "",
        city: "",
        email: "",
        state: "",
        pinCode: "",
        initialWallet: "",
        status: "",
        businessName: "",
        contactNumber: "",
        businessAddress: "",
        image: "",
        gst: "",
      },
    };
  },
  validations() {
    return {
      userdata: {
        firstName: {
          required: helpers.withMessage("First name is required.", required),
          alphaOnly: helpers.withMessage(
          "First name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
        },
        lastName: {
          required: helpers.withMessage("Last name is required.", required),
          alphaOnly: helpers.withMessage(
          "Last name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
        },
        mobile: {
          required: helpers.withMessage("Mobile number is required.", required),
           numeric: helpers.withMessage("Mobile number must be numeric.", numeric),
        maxLength: helpers.withMessage(
          "Mobile number must be 10 digits.",
          maxLength(10)
        ),
        validMobile: helpers.withMessage(
          "Mobile number must start with 6, 7, 8, or 9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
        },
        address: {
          required: helpers.withMessage("Address is required.", required),
        },
        city: { required: helpers.withMessage("City is required.", required),
            alphaOnly: helpers.withMessage(
          "City should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
         },
        pinCode: {
          required: helpers.withMessage("Pin code is required.", required),
           numeric: helpers.withMessage("Pin code must contain only numbers.", numeric),
  maxLength: helpers.withMessage("Pin code must be 6 digits.", maxLength(6)),
        },
        // initialWallet:{required:helpers.withMessage("InitialWallet is required.",required)},
      },
    };
  },
  mounted() {
    this.fetchingProfile();
  },
  methods: {
    async fetchingProfile() {
      try {
        const responseUserData = await NetworkService.get(
          `profile/${this.userId}`
        );
        const user = responseUserData.user;
        const usersData = responseUserData.user.user_details;
        this.userdata.firstName = usersData.first_name;
        this.userdata.lastName = usersData.last_name;
        this.userdata.mobile = user.mobile;
        this.userdata.email = user.email;
        this.userdata.address = usersData.address;
        this.userdata.city = usersData.city;
        this.userdata.pinCode = usersData.pincode;
        this.userdata.state = usersData.state;
        this.userdata.businessName = usersData.company_name;
        this.userdata.contactNumber = usersData.company_contact;
        this.userdata.businessAddress = usersData.company_address;
        // this.userdata.contact_number = usersData.contactNumber,
      } catch (error) {
        this.$refs.toast.show("Unable to fetching the user details.", "error");
      }
    },
   async updateUserDetails() {
  try {
    const isValid = await this.validator.$validate();
    if (!isValid) return;

    this.submitloadingSpinner = true;

    const updateUserProfile = {
      user_id: this.userId,
      first_name: this.userdata.firstName,
      last_name: this.userdata.lastName,
      mobile: this.userdata.mobile,
      address: this.userdata.address,
      pincode: this.userdata.pinCode,
      city: this.userdata.city,
      state: this.userdata.state,
      email: this.userdata.email,
      business_name: this.userdata.businessName,
      business_address: this.userdata.businessAddress,
      business_mobile: this.userdata.contactNumber,
    };

    const response = await NetworkService.post("/profile-edit", updateUserProfile);

    if (response.data.success === false) {
      this.submitloadingSpinner = false;
      const apiError = response.data.errors;
      if (apiError) {
        this.formErrors = apiError;
      }
      this.$refs.toast.show(response.data.message, "error");
      return;
    }

    this.formErrors = {};
    this.$refs.toast.show(response.data.message);
    this.submitloadingSpinner = false;

    // setTimeout(() => {
    //   if (this.roleId == "4") {
    //     this.$router.push(`/services`);
    //   } else if (this.roleId == "1") {
    //     this.$router.push("user-details/admin");
    //   } else if (this.roleId == "2") {
    //     this.$router.push("user-details/distributor");
    //   } else if (this.roleId == "3") {
    //     this.$router.push("user-details/retailer");
    //   }
    // }, 3000);
  } catch (error) {
    this.submitloadingSpinner = false;
    const apiError = error?.response?.data?.errors || error?.errors;
    if (apiError) {
      this.formErrors = apiError;
    } else {
      this.$refs.toast.show("Unable to update the user details.", "error");
    }
  }
},

    BackToDashboard() {
      if (this.roleId == "4") {
        this.$router.push(`/services`);
      } else if (this.roleId == "1") {
        this.$router.push("user-details/admin");
      } else if (this.roleId == "2") {
        this.$router.push("user-details/distributor");
      } else if (this.roleId == "3") {
        this.$router.push("user-details/retailer");
      }
    },
  },
};
</script>
